exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config h5[data-v-7fe87be6]{margin-left:20px}.config .head[data-v-7fe87be6]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:20px}.config .name[data-v-7fe87be6]{width:200px}.config .tab[data-v-7fe87be6]{margin-top:20px}.config .function-icon img[data-v-7fe87be6]{cursor:pointer;width:14px}.config .page[data-v-7fe87be6]{text-align:center;margin-top:20px}\n", ""]);

// exports
